import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductCertificates extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });

    const initialVariantId = this.#getInitialVariantId();
    if (initialVariantId) {
      this.#showVariant(initialVariantId);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * @returns {string | null}
   */
  #getInitialVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;

    const variantInput = document.querySelector('product-form-component input[name="id"]');
    if (variantInput instanceof HTMLInputElement && variantInput.value) {
      return variantInput.value;
    }

    return this.dataset.initialVariantId ?? null;
  }

  /**
   * @param {import('./events').VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    const eventProductId = event.detail.data?.newProduct?.id ?? event.detail.data?.productId;
    if (eventProductId && eventProductId !== this.dataset.productId) return;

    const variantId = event.detail.resource?.id;
    if (variantId) {
      this.#showVariant(String(variantId));
    }
  };

  /**
   * @param {string} variantId
   */
  #showVariant(variantId) {
    const panels = this.querySelectorAll('.product-certificates__variant');
    let hasVisibleContent = false;

    panels.forEach((panel) => {
      if (!(panel instanceof HTMLElement)) return;

      const isActive = panel.dataset.variantId === variantId;
      panel.hidden = !isActive;

      if (isActive && panel.querySelector('.product-certificates__table')) {
        hasVisibleContent = true;
      }
    });

    const emptyState = this.querySelector('.product-certificates__empty');
    if (emptyState instanceof HTMLElement) {
      emptyState.hidden = hasVisibleContent;
    }
  }
}

if (!customElements.get('product-certificates')) {
  customElements.define('product-certificates', ProductCertificates);
}
